import dayjs from 'dayjs';
import {useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import TimedMessageRequest, {
  iTimedMsgDateRange,
} from './request/TimedMessageRequest';
import {
  ITimedMessageDayType,
  ITimedMessageMsgType,
} from '../../../dto/timed-message/TimedMessageRequest.dto';
import {IStation} from '../../../dto/Station.dto';
import {companyIdSelector} from '../../../store/Slices/companySlice';
import {iTimedMsgTimesItem} from './request/times/TimedMsgRequestTimesCard';
import {iTimedMessageMessageItem} from './request/contents/TimedMsgRequestContentMessageCard';
import {useRqViewTimedMessagesByRequestID} from '../../../react_query/messages/timed-messages/ViewTimedMsgDetails';

const defaultMessages: iTimedMessageMessageItem[] = [
  {
    id: -1 * Date.now(),
    isNew: true,
    type: 'message',
    message: '',
    artist: '',
    title: '',
    label: 'Message',
  },
];

const defaultState = {
  defaultName: '',
  defaultStep: 0,
  defaultStations: [] as IStation[],
  defaultMessages,
  defaultDayType: 'no-end' as ITimedMessageDayType,
  defaultContentType: 'message' as ITimedMessageMsgType,
  defaultDateRanges: [
    {
      id: Date.now(),
      start_date: null,
      end_date: null,
    } as iTimedMsgDateRange,
  ],
  defaultTimeItems: [
    {
      id: Date.now(),
      selectedDays: [],
      timeRanges: [],
    },
  ] as iTimedMsgTimesItem[],
};

const TimedMessageCreate = ({
  onClose,
  setStatus,
  timedId,
  type,
}: {
  onClose: () => void;
  timedId?: number;
  type?: string;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const companyId = useSelector(companyIdSelector);
  const [state, setState] = useState({...defaultState});
  const {data, isFetching, isError} = useRqViewTimedMessagesByRequestID(
    Number(companyId),
    Number(timedId),
    Boolean(timedId) && type !== 'restore',
  );

  useEffect(() => {
    if (data && !isFetching && !isError) {
      const defaultMessages: iTimedMessageMessageItem[] =
        data.timed_sequences.map(o => {
          return {
            id: o.sequenceable_id,
            isNew: false,
            type: o.sequenceable_type === 'message' ? 'message' : 'song',
            message:
              o.sequenceable_type === 'message' ? o.sequenceable.message : '',
            artist: o.sequenceable.media_track?.track_artist ?? '',
            title: o.sequenceable.media_track?.track_name ?? '',
            label: o.sequenceable_type === 'message' ? 'Message' : 'Song',
            track: o.sequenceable.media_track,
          };
        });
      setState(prev => ({
        ...prev,
        defaultName: `${data.name} ${type === 'duplicate' ? 'duplicate' : ''}`,
        defaultStations: data.stations,
        defaultMessages: defaultMessages,
        defaultDayType: data.day_type,
        defaultContentType: data.message_type,
        defaultDateRanges: data.date_ranges.map(o => ({
          id: o.id,
          start_date: dayjs(o.start_date),
          end_date: dayjs(o.end_date),
        })),
        defaultTimeItems: data.day_times.map(o => {
          return {
            id: o.id,
            selectedDays: o.week_days.map(
              d => d.charAt(0).toUpperCase() + d.slice(1).toLowerCase(),
            ),
            timeRanges: o.start_times.map((t, i) => ({
              id: i,
              start_time: dayjs(t, 'HH:mm:ss'),
            })) as [],
          };
        }),
      }));
    }
  }, [data, isError, isFetching, type]);

  if (type === 'update') {
    return !isFetching && state.defaultName ? (
      <TimedMessageRequest
        onClose={onClose}
        {...state}
        updateId={timedId}
        messageStatus={data?.status ?? null}
        setStatus={setStatus}
      />
    ) : null;
  }

  if (type === 'duplicate') {
    return !isFetching && state.defaultName ? (
      <TimedMessageRequest
        onClose={onClose}
        {...state}
        isCopyForm
        messageStatus={null}
        setStatus={setStatus}
      />
    ) : null;
  }
  return (
    <TimedMessageRequest
      onClose={onClose}
      {...defaultState}
      restoreId={timedId}
      messageStatus={null}
      setStatus={setStatus}
    />
  );
};

export default TimedMessageCreate;
